import React, { useEffect, useState } from "react";
import StaffLayout from "@/components/StaffLayout";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export default function StaffDashboard() {
  const { user } = useAuth();
  const superadmin = user?.roles?.includes("superadmin_dcc");
  const [stats, setStats] = useState(null);
  const [timeline, setTimeline] = useState([]);
  const [notifs, setNotifs] = useState({ items: [], total: 0 });

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
    api.get("/admin/timeline/activations?days=90").then((r) => setTimeline(r.data));
    api.get("/admin/notifications?limit=20").then((r) => setNotifs(r.data));
  }, []);

  return (
    <StaffLayout user={user} superadmin={superadmin}>
      <div>
        <p className="text-xs uppercase tracking-widest text-[#93C5FD] font-semibold">{superadmin ? "Superadmin" : "Staff DCC"}</p>
        <h1 className="mt-2 text-3xl font-bold text-white font-display">Panel global</h1>

        {stats && (
          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3" data-testid="staff-stats">
            {Object.entries(stats).map(([k, v]) => (
              <div key={k} className="p-3 bg-[#111827] border border-gray-800 rounded-lg">
                <p className="text-[10px] uppercase tracking-widest text-gray-500">{k.replace(/_/g, " ")}</p>
                <p className="mt-1 font-mono text-xl font-bold text-white">{v}</p>
              </div>
            ))}
          </div>
        )}

        {timeline.length > 0 && (
          <section className="mt-8">
            <h2 className="text-sm uppercase tracking-widest text-gray-400 mb-3">Activaciones últimos 90 días</h2>
            <div className="p-4 bg-[#111827] border border-gray-800 rounded-xl h-64">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={timeline}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#1F2937" />
                  <XAxis dataKey="date" stroke="#9CA3AF" fontSize={10} />
                  <YAxis stroke="#9CA3AF" fontSize={10} />
                  <Tooltip contentStyle={{ background: "#0F172A", border: "1px solid #1F2937" }} />
                  <Line type="monotone" dataKey="count" stroke="#3B82F6" strokeWidth={2} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </section>
        )}

        <section className="mt-8">
          <h2 className="text-sm uppercase tracking-widest text-gray-400 mb-3">Outbox reciente</h2>
          <div className="overflow-x-auto border border-gray-800 rounded-xl">
            <table className="w-full text-sm">
              <thead className="bg-[#0F172A] text-xs uppercase tracking-widest text-gray-400">
                <tr>
                  <th className="text-left px-3 py-2">Tipo</th>
                  <th className="text-left px-3 py-2">Título</th>
                  <th className="text-left px-3 py-2">Estado</th>
                  <th className="text-left px-3 py-2">Fecha</th>
                </tr>
              </thead>
              <tbody>
                {notifs.items.slice(0, 15).map((n) => (
                  <tr key={n.id} className="border-t border-gray-800">
                    <td className="px-3 py-2 font-mono text-xs text-[#93C5FD]">{n.type}</td>
                    <td className="px-3 py-2 text-white">{n.title}</td>
                    <td className="px-3 py-2">
                      <span className={`text-[10px] px-2 py-0.5 rounded uppercase font-semibold ${
                        n.status === "sent" ? "bg-emerald-500/10 text-emerald-300 border border-emerald-500/30" :
                        n.status === "failed" ? "bg-red-500/10 text-red-300 border border-red-500/30" :
                        "bg-amber-500/10 text-amber-300 border border-amber-500/30"
                      }`}>{n.status}</span>
                    </td>
                    <td className="px-3 py-2 text-gray-500 font-mono text-xs">{new Date(n.created_at).toLocaleString("es-MX")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </StaffLayout>
  );
}
